import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.docs.draft');
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

type DraftStatus = 'draft' | 'review' | 'ready';
type DraftField = 'title' | 'summary' | 'sourceLink';

interface DraftDocumentState {
    title: string;
    summary: string;
    sourceLink: string;
    body: string;
    status: DraftStatus;
    savedAt: string;
}

const DRAFT_STORAGE_KEY = '__awesome_llm_draft_documents';

@Component({
    selector: 'wiz-page-docs-draft',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.docs.draft/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
}

:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}

.draft-shell {
  min-height: 100vh;
}

.draft-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.draft-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.draft-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  letter-spacing: 0;
  text-decoration: none;
}

.draft-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.draft-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 700;
  text-decoration: none;
}

.draft-nav a:hover,
.draft-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.draft-page {
  width: min(1240px, 100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr) 260px;
  gap: 18px;
  align-items: start;
}

.draft-toc,
.draft-article,
.draft-infobox {
  min-width: 0;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.draft-toc,
.draft-infobox {
  position: sticky;
  top: 80px;
  padding: 16px;
}

.draft-toc h2,
.draft-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 900;
  letter-spacing: 0;
}

.draft-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  display: grid;
  gap: 6px;
  list-style: none;
}

.draft-toc a {
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
  text-decoration: none;
}

.draft-toc a:hover,
.draft-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.draft-title,
.draft-editor,
.draft-preview {
  padding: 28px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.draft-preview {
  border-bottom: 0;
}

.draft-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 850;
}

.draft-title h1 {
  min-width: 0;
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
  font-weight: 900;
  letter-spacing: 0;
  overflow-wrap: anywhere;
}

.draft-summary {
  max-width: 780px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
  font-weight: 650;
}

.draft-badges {
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.draft-badges span {
  min-height: 28px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cfd7e3;
  border-radius: 999px;
  padding: 0 10px;
  color: #475467;
  background: #f8fafc;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 850;
}

.draft-editor {
  background: #f8fafc;
}

.draft-editor__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
}

.draft-editor__head span,
.editor-field span {
  color: #147a3b;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 900;
}

.draft-editor__head h2 {
  margin: 4px 0 0;
  color: #111827;
  font-size: 22px;
  line-height: 1.3;
  font-weight: 900;
  letter-spacing: 0;
}

.status-toggle,
.editor-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.status-toggle {
  justify-content: flex-end;
}

.status-toggle button,
.editor-action {
  min-height: 34px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  padding: 0 12px;
  color: #475467;
  background: #ffffff;
  font: inherit;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 850;
  cursor: pointer;
}

.status-toggle button:hover,
.status-toggle button:focus-visible,
.status-toggle button.is-active,
.editor-action:hover,
.editor-action:focus-visible {
  border-color: #147a3b;
  color: #ffffff;
  background: #147a3b;
  outline: none;
}

.editor-action--primary {
  border-color: #1d4f91;
  color: #ffffff;
  background: #1d4f91;
}

.editor-action--primary:hover,
.editor-action--primary:focus-visible {
  border-color: #163f75;
  background: #163f75;
}

.editor-grid {
  margin-top: 18px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.editor-field {
  min-width: 0;
  display: grid;
  gap: 7px;
}

.editor-field--wide {
  grid-column: span 2;
}

.editor-field input,
.editor-field textarea {
  width: 100%;
  min-width: 0;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  padding: 10px 12px;
  color: #202733;
  background: #ffffff;
  font: inherit;
  font-size: 13px;
  line-height: 1.55;
  outline: none;
}

.editor-field input:focus,
.editor-field textarea:focus {
  border-color: #147a3b;
  box-shadow: 0 0 0 3px rgba(20, 122, 59, 0.12);
}

.editor-field textarea {
  resize: vertical;
}

.editor-textarea {
  min-height: 340px;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
}

.editor-actions {
  margin-top: 14px;
}

.saved-at {
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  font-weight: 750;
}

.draft-preview h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
  font-weight: 900;
  letter-spacing: 0;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.preview-body {
  display: grid;
  gap: 12px;
}

.preview-body h3 {
  margin: 0;
  color: #111827;
  font-size: 20px;
  line-height: 1.35;
  font-weight: 900;
}

.preview-body p {
  margin: 0;
  color: #475467;
  font-size: 14px;
  line-height: 1.75;
  font-weight: 650;
}

.preview-body pre {
  margin: 0;
  overflow-x: auto;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  padding: 16px;
  color: #1f2937;
  background: #ffffff;
  font-size: 13px;
  line-height: 1.65;
  white-space: pre-wrap;
  word-break: break-word;
}

.draft-infobox dl {
  margin: 12px 0 0;
  display: grid;
  border-top: 1px solid #e4e8ef;
}

.draft-infobox dl div {
  min-width: 0;
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  border-bottom: 1px solid #e4e8ef;
}

.draft-infobox dt,
.draft-infobox dd {
  min-width: 0;
  margin: 0;
  padding: 10px 0;
  color: #475467;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.draft-infobox dt {
  color: #344054;
  font-weight: 900;
}

.draft-infobox a {
  color: #166534;
  font-weight: 850;
  text-decoration: none;
}

.draft-infobox a:hover,
.draft-infobox a:focus-visible {
  text-decoration: underline;
  outline: none;
}

.infobox-link {
  min-height: 36px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #166534;
  background: #ffffff;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 850;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #f0fdf4;
  text-decoration: none;
}

@media (max-width: 1120px) {
  .draft-page {
    grid-template-columns: 200px minmax(0, 1fr);
  }
  .draft-infobox {
    position: static;
    grid-column: 2;
  }
}
@media (max-width: 860px) {
  .draft-topbar__inner,
  .draft-page {
    width: min(100% - 24px, 1240px);
  }
  .draft-topbar__inner {
    min-height: auto;
    padding: 12px 0;
    align-items: flex-start;
    flex-direction: column;
  }
  .draft-page {
    grid-template-columns: 1fr;
    padding-top: 14px;
  }
  .draft-toc,
  .draft-infobox {
    position: static;
  }
  .draft-infobox {
    grid-column: auto;
  }
  .draft-title,
  .draft-editor,
  .draft-preview {
    padding-left: 18px;
    padding-right: 18px;
  }
  .draft-title h1 {
    font-size: 30px;
  }
  .draft-editor__head,
  .editor-grid {
    display: grid;
    grid-template-columns: 1fr;
  }
  .status-toggle {
    justify-content: flex-start;
  }
  .editor-field--wide {
    grid-column: span 1;
  }
}`],
})
export class PageDocsDraftComponent implements OnInit {
    public draftId = '';
    public title = '새 위키 문서';
    public summary = this.defaultSummary();
    public sourceLink = '';
    public body = this.defaultBody();
    public status: DraftStatus = 'draft';
    public savedAt = '';
    public readonly statuses: Array<{ id: DraftStatus; label: string }> = [
        { id: 'draft', label: '초안' },
        { id: 'review', label: '검토' },
        { id: 'ready', label: '반영 대기' },
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,    ) { }

    public get documentPath(): string {
        return `/docs/draft/${this.draftId || 'draft'}`;
    }

    public get statusLabel(): string {
        return this.statuses.find((item) => item.id === this.status)?.label || '초안';
    }

    public get sourceLabel(): string {
        return this.sourceLink || '미입력';
    }

    public async ngOnInit() {
        await this.service.init();
        this.draftId = this.resolveDraftId();
        this.loadDraft();
        await this.service.render();
    }

    public updateField(field: DraftField, event: Event) {
        const input = event.target as HTMLInputElement | HTMLTextAreaElement;
        const value = input.value || '';

        if (field === 'title') {
            this.title = value;
        }

        if (field === 'summary') {
            this.summary = value;
        }

        if (field === 'sourceLink') {
            this.sourceLink = value;
        }

        this.persistDraft();
    }

    public updateBody(event: Event) {
        const input = event.target as HTMLTextAreaElement;
        this.body = input.value || '';
        this.persistDraft();
    }

    public async setStatus(status: DraftStatus) {
        this.status = status;
        this.persistDraft();
        await this.service.render();
    }

    public async generateFromSource() {
        const source = this.extractSourceName(this.sourceLink);
        this.summary = `${source} 기준으로 정리 중인 Awesome LLM Wiki 문서 초안입니다. 핵심 내용, 적용 기준, 검수 포인트를 한 문서에서 작성합니다.`;
        this.body = [
            `# ${this.title || '새 위키 문서'}`,
            '',
            '## 1. 개요',
            `${source}에서 확인한 내용을 Awesome LLM Wiki 문서 규격에 맞춰 정리합니다.`,
            '',
            '## 2. 핵심 내용',
            '- 문서가 답해야 하는 질문',
            '- 공식 출처 또는 근거',
            '- 기존 문서와 연결할 지점',
            '',
            '## 3. 검수 기준',
            '- 출처 확인 여부',
            '- 공개 목차 반영 여부',
            '- 갱신 주기와 담당자',
            '',
            '## 4. 참고 자료',
            `- ${this.sourceLink || '출처 링크 미입력'}`,
        ].join('\n');
        this.persistDraft();
        await this.service.render();
    }

    public async saveDraft() {
        this.savedAt = this.formatDateTime(new Date());
        this.persistDraft();
        await this.service.render();
    }

    public trackByStatus(_: number, status: { id: DraftStatus }) {
        return status.id;
    }

    private loadDraft() {
        const shared = this.getSharedState();
        const stored = this.readStoredDrafts()[this.draftId];
        const created = this.findCreatedDraft(shared);
        const draft = stored || shared.draftDocuments?.[this.draftId];

        this.title = draft?.title || created?.title || '새 위키 문서';
        this.summary = draft?.summary || this.defaultSummary();
        this.sourceLink = draft?.sourceLink || '';
        this.body = draft?.body || this.defaultBody();
        this.status = this.toDraftStatus(draft?.status);
        this.savedAt = draft?.savedAt || '';
    }

    private persistDraft() {
        if (!this.draftId) {
            return;
        }

        const draft: DraftDocumentState = {
            title: this.title,
            summary: this.summary,
            sourceLink: this.sourceLink,
            body: this.body,
            status: this.status,
            savedAt: this.savedAt,
        };

        const shared = this.getSharedState();
        shared.draftDocuments = shared.draftDocuments || {};
        shared.draftDocuments[this.draftId] = draft;

        const stored = this.readStoredDrafts();
        stored[this.draftId] = draft;
        this.writeStoredDrafts(stored);
    }

    private resolveDraftId(): string {
        const fromRoute = this.route.snapshot.paramMap.get('draftId');
        const fromWiz = (window as any).WizRoute?.segment?.draftId;
        const fromUrl = window.location.pathname.match(/\/docs\/draft\/([^/?#]+)/)?.[1];
        return decodeURIComponent(fromRoute || fromWiz || fromUrl || 'draft');
    }

    private findCreatedDraft(shared: any): { title?: string } | undefined {
        const created = shared.draftDocument;

        if (!created) {
            return undefined;
        }

        if (created.href === this.documentPath || created.href === `/main/wiki-operations/${this.draftId}`) {
            return created;
        }

        return undefined;
    }

    private readStoredDrafts(): Record<string, DraftDocumentState> {
        try {
            return JSON.parse(window.localStorage.getItem(DRAFT_STORAGE_KEY) || '{}');
        } catch (_) {
            return {};
        }
    }

    private writeStoredDrafts(value: Record<string, DraftDocumentState>) {
        try {
            window.localStorage.setItem(DRAFT_STORAGE_KEY, JSON.stringify(value));
        } catch (_) { }
    }

    private getSharedState() {
        const root = window as any;
        root.__mainWikiState = root.__mainWikiState || {};
        return root.__mainWikiState;
    }

    private toDraftStatus(value?: string): DraftStatus {
        if (value === 'review' || value === 'ready') {
            return value;
        }

        return 'draft';
    }

    private extractSourceName(value: string): string {
        if (!value.trim()) {
            return '입력된 출처';
        }

        try {
            return new URL(value).hostname.replace(/^www\./, '');
        } catch (_) {
            return value.trim();
        }
    }

    private defaultSummary(): string {
        return '아직 공개 목차에 반영되지 않은 문서 초안입니다. 이 페이지 안에서 본문을 작성하고 검토 상태를 관리합니다.';
    }

    private defaultBody(): string {
        return [
            '# 새 위키 문서',
            '',
            '## 1. 개요',
            '문서가 다루는 주제와 사용자가 이 문서를 읽어야 하는 이유를 적습니다.',
            '',
            '## 2. 핵심 내용',
            '- 주요 개념',
            '- 비교 기준',
            '- 운영 시 주의할 점',
            '',
            '## 3. 참고 자료',
            '- 출처 링크와 확인 날짜를 남깁니다.',
        ].join('\n');
    }

    private formatDateTime(value: Date): string {
        const year = value.getFullYear();
        const month = `${value.getMonth() + 1}`.padStart(2, '0');
        const date = `${value.getDate()}`.padStart(2, '0');
        const hours = `${value.getHours()}`.padStart(2, '0');
        const minutes = `${value.getMinutes()}`.padStart(2, '0');

        return `${year}-${month}-${date} ${hours}:${minutes}`;
    }
}

export default PageDocsDraftComponent;